import { useState } from "react"

export default function NumebrSelect({ numbers = [1], setValue, defaultValue }: any) {
  const [isOpen, setIsOpen] = useState(false)

  const changeValue = (e: any) =>{
    const newValue = e.target.textContent
    setValue(Number(newValue[1]))
    setIsOpen(false)
  }

  return (<>
    <div className="numberSelectContainer">
      <div className="defaultValue" onClick={() => setIsOpen(!isOpen)}>
        <p>{`0${defaultValue}`}</p>
      </div>
      <div className="options" style={{display: `${(isOpen) ? 'block' : 'none'}`}}>
        {numbers.map((number: number) => <p className="option" onClick={changeValue}>{`0${number}`}</p>)}
      </div>
    </div>
  </>)
}